import { Node_Type } from "./../../ricos-types/index.js";
import { Embed } from "./embed.js";
import { LinkPreview } from "./link-preview.js";
const nodeViewRenderers = {
  [Node_Type.LINK_PREVIEW]: LinkPreview,
  [Node_Type.EMBED]: Embed
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers.js.map
